import en from './en.json'
import cn from './cn.json'
import pt from './pt.json'


export default {
	en,
	cn,
	pt,
}
